import React, { useContext, useEffect } from "react";
import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
} from "react-router-dom";

import AccountPage from "containers/AccountPage/AccountPage";
import Page404 from "containers/Page404/Page404";
import PageHome from "containers/PageHome/PageHome";
import Footer from "shared/Footer/Footer";
import ScrollToTop from "./ScrollToTop";

import PageLogin, { UserState } from "containers/PageLogin/PageLogin";

import PageCollection from "containers/PageCollection";
import SiteHeader from "containers/SiteHeader";

import AccountPass from "containers/AccountPage/AccountPass";
import AccountSavelists from "containers/AccountPage/AccountWishlis";
import AccountProducts from "containers/dash/Shop/AccountProducts";

import AddProduct from "containers/AccountPage/AddProduct";
import Messages from "containers/AccountPage/Messages";
import { Toaster } from "react-hot-toast";
import { useSelector } from "react-redux";
import { RootState } from "../app/store";

import { WebsocketContext } from "App";
import Notify from "components/Notify";
import AccountOrder from "containers/AccountPage/AccountOrder";
import AccountSales from "containers/AccountPage/AccountSales";
import EditProduct from "containers/AccountPage/EditProduct";
import CheckoutPage from "containers/PageCheckout/CheckoutPage";
import PageContact from "containers/PageContact/PageContact";
import PageForgot from "containers/PageForgot/PageForgot";
import Active from "containers/PageSignUp/Active";
import PageSubcription from "containers/PageSubcription/PageSubcription";
import ProductDetailPage from "containers/ProductDetailPage/ProductDetailPage";
import AccountBoost from "containers/dash/Boost/AccountBoost";
import Dashboard from "containers/dash/Dashboard";
import toast from "react-hot-toast";
import PageSignUp from "../containers/PageSignUp/PageSignUp";
export const pages = [
  { path: "/", exact: true, component: PageHome },
  { path: "/#", exact: true, component: PageHome },
  { path: "/login", exact: true, component: PageLogin },
  { path: "/signup", exact: true, component: PageSignUp },

  { path: "/shop", component: PageCollection },
  { path: "/shop/:market", component: PageCollection },

  { path: "/shop/:slug/:id", component: ProductDetailPage },

  { path: "/contact", component: PageContact },
  { path: "/abonnement", component: PageSubcription },

  { path: "/active/:token", component: Active },
  { path: "/forgot-pass", component: PageForgot },
  { path: "/forgot-pass/:token", component: PageForgot },

  //
];
export const privatePages = [
  { path: "/account", exact: true, component: AccountPage },
  { path: "/wishlist", component: AccountSavelists },
  { path: "/password", component: AccountPass },
  { path: "/add", component: AddProduct },

  { path: "/messages/", component: Messages },
  { path: "/messages/:username", component: Messages },
  { path: "/mesproduits", component: AccountProducts },
  { path: "/boost", component: AccountBoost },
];
export const privatePagesDash = [
  { path: "/", exact: true, component: Dashboard },
  { path: "/account", exact: true, component: AccountPage },
  { path: "/wishlist", component: AccountSavelists },
  { path: "/password", component: AccountPass },
  { path: "/add", component: AddProduct },
  { path: "/edit/:id", component: EditProduct },
  { path: "/messages/", component: Messages },
  // { path: "/messages2/", component: ChatPage },

  { path: "/messages/:username", component: Messages },
  { path: "/mesproduits", component: AccountProducts },
  { path: "/boost", component: AccountBoost },
  { path: "/checkout", component: CheckoutPage },
  { path: "/order", component: AccountOrder },
  { path: "/sales", component: AccountSales },
];
const ProtectedRoute = () => {
  const userLogin = useSelector<RootState, UserState>(
    (state: RootState) => state.authorizationReducer
  );
  const { loggedIn } = userLogin;

  if (!loggedIn) {
    return <Navigate to={"/login"} replace />;
  }

  return <Outlet />;
};

const MainLayoutRoutes = () => {
  return (
    <React.Fragment>
      <SiteHeader />
      <Routes>
        {pages.map(({ component: Component, path }, index) => {
          return <Route key={index} element={<Component />} path={path} />;
        })}
        {/* <Route element={<ProtectedRoute  />}>
            {privatePagesDash.map(({ component: Component, path }, index) => {
              return <Route key={index} element={<Component />} path={path} />;
            })}
          </Route> */}
        <Route path="*" element={<Page404 />} />
      </Routes>
      <Footer />
    </React.Fragment>
  );
};

const DashRoutes = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route element={<ProtectedRoute />}>
          {privatePagesDash.map(({ component: Component, path }, index) => {
            return <Route key={index} element={<Component />} path={path} />;
          })}
        </Route>
        <Route path="*" element={<Page404 />} />
      </Routes>
    </React.Fragment>
  );
};

const MyRoutes = () => {
  const ret = useContext(WebsocketContext); // use it just like a hook

  useEffect(() => {
    const d = JSON.parse(ret.value);
    console.log(d);
    if (d?.ws_type == "notif") {
      console.log(d);
      toast.custom((t) => <Notify t={t} message={d?.message} status="info" />);
    }
  }, [ret.value]);
  return (
    <BrowserRouter>
      <Toaster position="top-right" />
      <ScrollToTop />

      {/* <SiteHeader /> */}
      <Routes>
        {/* {pages.map(({ component: Component, path }, index) => {
            return <Route key={index} element={<Component />} path={path} />;
          })}
          <Route element={<ProtectedRoute  />}>
            {privatePages.map(({ component: Component, path }, index) => {
              return <Route key={index} element={<Component />} path={path} />;
            })}
          </Route> */}
        <Route path="*" element={<MainLayoutRoutes />} />
        <Route path="/dash/*" element={<DashRoutes />} />
        {/* <Route path="*" element={<Page404 />} /> */}
      </Routes>
      {/* <Footer /> */}
    </BrowserRouter>
  );
};

export default MyRoutes;
